<template>
  <vs-button
    type="border"
    class="rounded-lg px-3 py-2 mr-2"
    :color="properties.color || 'primary'"
    @click="$emit('pressed')"
  >
    <feather-icon :icon="properties.icon || 'PlusIcon'" svgClasses="align-middle w-5" />
    <span v-if="properties.label" class="hidden 2xl:inline-block ml-2">
      {{ properties.label }}
    </span>
  </vs-button>
</template>

<script>
export default {
  name: 'field-action-button',
  props: {
    properties: { type: Object, required: true }
  }
}
</script>
